import React, { Component } from 'react';
import { Toast } from 'antd-mobile';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import SendVRCode from '../../components/sendVRCode';
import { orderLogin } from '../../service/chat-service';

import styles from './styles.module.less';
import phoneImage from './img/login_phone.png';
import bgImage from './img/bg-190hjnj.png';

const propTypes = {
  history: PropTypes.arrayOf(PropTypes.string),
};
const defaultProps = {
  history: [],
};

/**
 * 物流登录
 */
class Logistics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phone: '',
      VRCode: '',
    };
  }

  componentDidMount() {
    window.document.title = '登录';
  }

  handleChange = (key) => (event) => {
    const { value } = event.target;
    this.setState({ [key]: value });
  };

  scrollPosition = () => {
    const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
    window.scrollTo(0, Math.max(scrollHeight - 1, 0));
  };

  handleLogin = async () => {
    const { history } = this.props;
    const { phone, VRCode } = this.state;
    const windowHref = `?${decodeURIComponent(window.location.href).split('?')[1]}`;
    const { id } = queryString.parse(windowHref);

    try {
      await orderLogin(phone, VRCode);
      if (id) {
        history.push(`/personalCenter?id=${id}`);
      } else {
        history.push('/myorderlogistics');
      }
    } catch (e) {
      Toast.show(e.message);
    }
  };

  render() {
    const { phone, VRCode } = this.state;
    return (
      <div className={styles.logisticsContent}>
        <div className={styles.bg}>
          <img src={bgImage} alt="" />
        </div>
        <div className={styles.content}>
          <div className={styles.item}>
            <img src={phoneImage} alt="phone" />
            <input
              type="text"
              onBlur={this.scrollPosition}
              maxLength={11}
              onChange={this.handleChange('phone')}
              value={phone}
              placeholder="请输入手机号"
            />
          </div>
          <div className={styles.item}>
            <input
              type="text"
              onBlur={this.scrollPosition}
              placeholder="验证码"
              maxLength={6}
              onChange={this.handleChange('VRCode')}
              value={VRCode}
            />
            <div className={styles.right}>
              <SendVRCode
                className={styles.sendCode}
                type={2}
                phoneNumber={phone || undefined}
              />
            </div>
          </div>
        </div>
        <div
          className={styles.button}
          onClick={this.handleLogin}
          role="button"
          tabIndex={0}
        >
          登录
        </div>
      </div>
    );
  }
}

Logistics.propTypes = propTypes;
Logistics.defaultProps = defaultProps;

export default Logistics;
